var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"cell",staticClass:"input-cell",attrs:{"contenteditable":"true"},on:{"blur":_vm.onBlur,"focus":_vm.onFocus,"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }